export default __webpack_public_path__ + "static/media/beauty-small.8df07bf1.png";